import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';
export const featuresIcons = {
  /* activities */
  activity_search_criterion_archery: {
    icon: ICONS.ARCHERY,
  },
  activity_search_criterion_climbing: {
    icon: ICONS.CLIMBING,
  },
  activity_search_criterion_creactive: {
    icon: ICONS.CREACTIVE,
  },
  activity_search_criterion_cycling_mountain_biking: {
    icon: ICONS.VTT,
  },
  activity_search_criterion_dance: {
    icon: ICONS.DANCE,
  },
  activity_search_criterion_entertainment: {
    icon: ICONS.DANCE,
  },
  activity_search_criterion_fitness: {
    icon: ICONS.CARDIO_TRAINING,
  },
  activity_search_criterion_fitness_and_work_out: {
    icon: ICONS.CARDIO_TRAINING,
  },
  activity_search_criterion_flying_trapeze_circus: {
    icon: ICONS.TRAPEZE,
  },
  activity_search_criterion_football: {
    icon: ICONS.SPORT,
  },
  activity_search_criterion_golf: {
    icon: ICONS.GOLF,
  },
  activity_search_criterion_horseriding: {
    icon: ICONS.RIDING,
  },
  activity_search_criterion_ice_skating: {
    icon: ICONS.ICE_SKATING,
  },
  activity_search_criterion_kayak: {
    icon: ICONS.KAYAK,
  },
  activity_search_criterion_kitesurfing: {
    icon: ICONS.KITESURF,
  },
  activity_search_criterion_nordic_walking: {
    icon: ICONS.NORDIC_WALKING,
  },
  activity_search_criterion_padel_tennis: {
    icon: ICONS.PADEL_TENNIS,
  },
  activity_search_criterion_pickleball: {
    icon: ICONS.PICKLEBALL,
  },
  activity_search_criterion_sailing: {
    icon: ICONS.SAILING,
  },
  activity_search_criterion_scuba_diving: {
    icon: ICONS.DIVING,
  },
  activity_search_criterion_skiing_snowboarding: {
    icon: ICONS.SKI,
  },
  activity_search_criterion_snorkelling: {
    icon: ICONS.SNORKELLING,
  },
  activity_search_criterion_snowboard: {
    icon: ICONS.SNOWBOARD,
  },
  activity_search_criterion_snow_shoe_walks: {
    icon: ICONS.SKI_IN_OUT,
  },
  activity_search_criterion_stand_up_paddle: {
    icon: ICONS.STAND_UP_PADDLE,
  },
  activity_search_criterion_volleyball: {
    icon: ICONS.SPORT_SCHOOL,
  },
  activity_search_criterion_surfing: {
    icon: ICONS.TRIDENT1,
  },
  activity_search_criterion_swimming: {
    icon: ICONS.SWIM,
  },
  activity_search_criterion_tai_chi: {
    icon: ICONS.TRIDENT1,
  },
  activity_search_criterion_tennis: {
    icon: ICONS.TENNIS,
  },
  activity_search_criterion_trail: {
    icon: ICONS.RUNNING,
  },
  activity_search_criterion_treeetop_adventure: {
    icon: ICONS.TREETOP_ADVENTURE,
  },
  activity_search_criterion_walking_hiking: {
    icon: ICONS.WALKING,
  },
  activity_search_criterion_waterskiing_wakeboarding: {
    icon: ICONS.WATERSKI,
  },
  activity_search_criterion_whitewater_sports: {
    icon: ICONS.TRIDENT1,
  },
  activity_search_criterion_wingfoil: {
    icon: ICONS.WINGFOIL,
  },
  activity_search_criterion_windsurfing: {
    icon: ICONS.WINDSURFING,
  },
  activity_search_criterion_yoga: {
    icon: ICONS.YOGA,
  },

  /* childcare */
  activity_search_criterion_petit_club: {
    color: COLORS.TURQUOISE,
    icon: ICONS.PETIT_CLUB,
  },
  activity_search_criterion_mini_club: {
    color: COLORS.WHITE,
    textColor: COLORS.BLUE_WAVE,
    icon: ICONS.MINI_CLUB_PLUS,
  },
  activity_search_criterion_mini_club_plus: {
    color: COLORS.WHITE,
    textColor: COLORS.BLUE_WAVE,
    icon: ICONS.MINI_CLUB_PLUS,
  },
  activity_search_criterion_baby_club: {
    color: COLORS.SIENNA,
    icon: ICONS.BABY_CLUB,
  },
  activity_search_criterion_passworld: {
    color: COLORS.BLACK,
    icon: ICONS.PASSWORLD,
  },
  activity_search_criterion_junior: {
    color: COLORS.BLACK,
    icon: ICONS.JUNIOR,
  },
};
